<div>
  <div class="top-corner">
    <h3>
      Moteurs
    </h3>
    <button mat-button class="cta-button" (click)="addNewRow()"><mat-icon>add</mat-icon>Nouveau</button>

  </div>

  <div class="mat-elevation-z8" >

    <mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="id">
        <mat-header-cell *matHeaderCellDef mat-sort-header> ID </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.id}} </mat-cell>

      </ng-container>
      <!-- -->

      <!-- <ng-container matColumnDef="makeCode">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Code Marque</mat-header-cell>
      <mat-cell *matCellDef="let element">
        <span >{{element.makeCode}}</span>
        <input [hidden]="!(editingItem && element.id===editingItemId)" matInput [(ngModel)]="editedItem.code"
          placeholder="Code" >
        </mat-cell>
      </ng-container>
      -->
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Moteur </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <span [hidden]="(editingItem && element.id===editingItemId)">{{element.name}}</span>
          <input [hidden]="!(editingItem && element.id===editingItemId)" matInput [(ngModel)]="editedItem.name"
            placeholder="Nom" >
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="fuel">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Carburant </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <span [hidden]="(editingItem && element.id===editingItemId)">{{element.fuel}}</span>
            <!-- <input [hidden]="!(editingItem && element.id===editingItemId)" matInput [(ngModel)]="editedItem.manufacturerId"
            placeholder="Constructeur" > -->

            @if ((editingItem && element.id===editingItemId)) {
              <mat-select matInput name="fuel" [(ngModel)]="editedItem.fuel" placeholder="Carburant">
                @for (item of carFuelTypes; track item) {
                  <mat-option [value]="item" >{{item}}</mat-option>
                }
              </mat-select>
            }
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="powerKw">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Puissance (KW) </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <span [hidden]="(editingItem && element.id===editingItemId)">{{element.powerKw}}</span>
            <input type=number [hidden]="!(editingItem && element.id===editingItemId)" matInput [(ngModel)]="editedItem.powerKw"
              placeholder="Puissance (KW)" >
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="powerHp">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Puissance (CV) </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <span [hidden]="(editingItem && element.id===editingItemId)">{{element.powerHp}}</span>
              <input type=number [hidden]="!(editingItem && element.id===editingItemId)" matInput [(ngModel)]="editedItem.powerHp"
                placeholder="Puissance (CV)" >
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="manufacturerName">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Constructeur </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <span [hidden]="(editingItem && element.id===editingItemId)">{{element.manufacturerName}}</span>
                <!-- <input [hidden]="!(editingItem && element.id===editingItemId)" matInput [(ngModel)]="editedItem.manufacturerId"
                placeholder="Constructeur" > -->

                @if ((editingItem && element.id===editingItemId)) {
                  <mat-select matInput name="manufacturerName" [(ngModel)]="editedItem.manufacturerId" placeholder="Constructeur">
                    @for (manuf of manufacturers; track manuf) {
                      <mat-option [value]="manuf.id" >{{manuf.name}}</mat-option>
                    }
                  </mat-select>
                }
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="lastUpdated">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Modifié le </mat-header-cell>
              <mat-cell *matCellDef="let element" > {{dateTimeFormat(element.lastUpdated)}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="actions">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Actions </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <button mat-button class="simple-button" (click)="editItem(element.id)" [hidden]="(editingItem && element.id===editingItemId)"><mat-icon>edit</mat-icon></button>
                <button mat-button class="simple-button" (click)="SaveItem(element.id)" [hidden]="!(editingItem && element.id===editingItemId)" [disabled]="!editedItemIsValid()">
                  <mat-icon>save</mat-icon>
                </button>
                <button mat-button class="simple-button" (click)="deleteItem(element.id)"><mat-icon>{{editingItem && element.id===editingItemId ? 'undo' : 'delete'}}</mat-icon>{{editingItem && element.id===editingItemId ? '' : ''}}</button>
              </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

          </mat-table>

          <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
        </div>

      </div>
